import React, { Component } from 'react';
import moment from "moment";
import _ from 'lodash';
import Pagination from "rc-pagination";
import {getCaseHistory} from "../../containers/History/actions";
import {connect} from "react-redux";
import Spinner from "../Spinner";

const fieldsToSkipValues = ['the images'];
const HISTORY_VIEW = 'History';
const NOTIFICATIONS_VIEW = 'Notifications';

class History extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: HISTORY_VIEW,
            caseHistoryOptions: {
                historyPage: 1,
                historyLimit: 5,
            },
            notificationHistoryOptions: {
                notificationsPage: 1,
                notificationsLimit: 5,
            },

            option: {
                noDataText: 'No change is available yet.',
                page: 1,
            },
            loading: true
        };
    }

    componentDidMount() {
        this.getCaseHistoryLogs()
    }

    getCaseHistoryLogs() {
        const pagination  = {
            ...this.state.caseHistoryOptions,
            ...this.state.notificationHistoryOptions,
        }
        this.props.getCaseHistory(this.props.caseId, pagination);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.historyLogs.loading && this.props.historyLogs.loading) {
            this.setState({loading: false});
        }
    }

    formatChanges(changes) {
        return changes.map(change => {
            let formattedChange = ` ${change.fieldTitle}`;
            if (change.changes) {
                formattedChange = change.changes.map(el => {
                    return ` ${el.from.title} from ${el.from.value} to ${el.to.value}`;
                }).join(', ')
            }
            else if (change.to && change.from && !fieldsToSkipValues.includes(change.fieldTitle)) {
                if(typeof change.from === "number" && change.fieldTitle !== "the number of units"){
                    const fromName = [];
                    const toName = [];
                    this.props.historyLogs.logs.patients.forEach((patient)=>{
                        if(patient.id === change.from){
                            fromName.push(patient);
                        }
                        if(patient.id === change.to){
                            toName.push(patient)
                        }
                    })
                    if(fromName.length && toName.length){
                        formattedChange += ` from ${fromName[0] && fromName[0].first_name + ' ' + fromName[0].last_name} to ${toName[0] && toName[0].first_name + ' ' + toName[0].last_name}`;
                    }
                }else{
                    formattedChange += ` from ${change.from} to ${change.to}`;
                }
            }
            return formattedChange;
        })
    }

    formatUserName(id) {
        const user = this.props.historyLogs.logs.users.find(user => user.id === id);
        if (user) {
            return `${user.first_name} ${user.last_name}`;
        }
        return 'System';
    }

    formatDate(date) {
        return moment(date).format('DD/MM/YYYY');
    }

    onHistoryPageChange(page) {
        this.setState({
            caseHistoryOptions: {
                ...this.state.caseHistoryOptions,
                historyPage: page,
            },
            loading: true,
        }, this.getCaseHistoryLogs);
    }
    onNotificationsPageChange(page) {
        this.setState({
            notificationHistoryOptions: {
                ...this.state.notificationHistoryOptions,
                notificationsPage: page,
            },
            loading: true,
        }, this.getCaseHistoryLogs);
    }

    onChangePage = (page) => {
        if (!this.state.loading) {
            if (this.state.view === HISTORY_VIEW) {
                this.onHistoryPageChange(page);
            } else {
                this.onNotificationsPageChange(page);
            }
        }
    }

    getCurrent() {
        const { historyPage } = this.state.caseHistoryOptions;
        const { notificationsPage } = this.state.notificationHistoryOptions;
        return this.state.view === HISTORY_VIEW ? historyPage : notificationsPage;
    }
    getPageSize() {
        const { historyLimit } = this.state.caseHistoryOptions;
        const { notificationsLimit } = this.state.notificationHistoryOptions;
        return this.state.view === HISTORY_VIEW ? historyLimit : notificationsLimit;
    }

    onChangeView = (viewSet) => {
        //const view = this.state.view === HISTORY_VIEW ? NOTIFICATIONS_VIEW : HISTORY_VIEW;
        this.setState({ view:viewSet });
    }

    render() {
        if (this.state.loading) {
            return <Spinner />
        }
        const key = this.state.view === NOTIFICATIONS_VIEW ? 'notificationLogs' : 'historyLogs';
        const { count, data } = this.props.historyLogs.logs[key];

        return (<div className="history-table">
                <div className="history-table__tab">
                    <div
                        className={`tab-item ${this.state.view === HISTORY_VIEW ? 'active' : ''}`}
                        onClick={() => this.onChangeView(HISTORY_VIEW)}
                    >
                        { HISTORY_VIEW }
                    </div>
                    <div
                        className={`tab-item ${this.state.view === NOTIFICATIONS_VIEW ? 'active' : ''}`}
                        onClick={() => this.onChangeView(NOTIFICATIONS_VIEW)}
                    >
                        { NOTIFICATIONS_VIEW }
                    </div>
                </div>
                <div className="history-table__container">
                    {
                        this.state.view === NOTIFICATIONS_VIEW ? (
                            <ul>
                                { data && data.map((logItem, index) => (
                                    <li key={index} ><span>{`${this.formatDate(logItem.updatedAt)}:`}</span><div>{`${this.formatUserName(logItem.to)} was sent ${logItem.type === 'email' ? 'an' : 'a'} ${logItem.type} with ${logItem.content} content`} </div></li>
                                )) }
                            </ul>
                        ) : (
                            <ul>
                                { data && data.map((logItem, index) => (
                                    <li key={index} ><span>{`${this.formatDate(logItem.updatedAt)}:`}</span><div>{`${this.formatUserName(logItem.updatedBy)} changed ${this.formatChanges(logItem.changes)}`}</div> </li>
                                )) }
                            </ul>
                        )
                    }
                </div>
                <Pagination
                    locale={{ prev_page: 'prev', next_page: 'next'}}
                    className="pagination__rc"
                    showLessItems
                    hideOnSinglePage
                    onChange={this.onChangePage}
                    current={this.getCurrent()}
                    total={count}
                    pageSize={this.getPageSize()}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return ({
        historyLogs: state.historyLogs
    });
}
const mapDispatchToProps = dispatch => {
    return {
        getCaseHistory: (caseId, pagination) => dispatch(getCaseHistory(caseId, pagination))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(History);


// WEBPACK FOOTER //
// ./src/components/History/index.js